<template>
  <div class="flashSale-container">
    <div class="titleBox" v-if="flashSaleList.length > 0">
      <span class="title">
        限时秒杀
        <!-- 装饰-左 -->
        <div class="decoration left">
          <div class="decoration-line"></div>
        </div>
        <!-- 装饰-右 -->
        <div class="decoration right">
          <div class="decoration-line"></div>
        </div>
      </span>
      <div class="moreBox" @click="handleLookMore">
        <span class="lookMore">查看更多</span>
        <el-icon class="el-icon-arrow-right"></el-icon>
      </div>
    </div>
    <div class="listBox" v-if="flashSaleList.length > 0">
      <div class="goodList">
        <div class="goodItem" v-for="(good, index) of flashSaleList.slice(0, 4)" :key="index" @click="handleActivityDetail(good)">
          <div class="img">
            <img :src="good.imgs[0].img" alt="">
            <img v-if="good.showStock <= 0" class="soldOut1" src="@/assets/images/pt-soldOut.png" alt="">
          </div>
          <div class="info">
            <div>
              <div class="storeCommodity">
                <img class="UImg" v-if="good.state === 'U'" src="@/assets/images/pt/yxdp.png" alt="">
                <img class="SImg" v-if="good.state === 'S'" src="@/assets/images/pt/zy.png" alt="">
                <div class="commodityName">{{ good.commodityName }}</div>
              </div>
            </div>
            <div class="price">
              <span class="retail" v-if="good.pays[0].payType === 1">
                <span class="symbol">¥</span>{{ minRetailPrice(good.activitySkus, 'discountPrice')?.discountPrice }}
              </span>
              <span class="retail" v-if="good.pays[0].payType === 2">
                {{ minRetailPrice(good.activitySkus, 'discountPrice')?.discountPrice }}&nbsp;提货值
              </span>
              <span class="original" v-if="good.pays[0].payType === 1">
                <span class="symbol">¥</span>{{ minRetailPrice(good.activitySkus, 'discountPrice')?.retailPrice }}</span>
              <span class="original" v-if="good.pays[0].payType === 2">
                {{ minRetailPrice(good.activitySkus, 'discountPrice')?.retailPrice }}&nbsp;提货值
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*global protocol http */
export default {
  data() {
    return {
      flashSaleList: []
    }
  },
  created() {
    this.queryAllflashSale()
  },
  methods: {
    // 查看更多
    handleLookMore() {
      // 清空限时抢购的状态，确保从首页进入时显示默认状态
      this.$store.commit('pt/setTimeLimitStatusOrder', null)
      this.$router.push('/timeLimit')
    },
    // 筛选skus对象数组中对象的property属性是最小值的对象
    minRetailPrice(skus, property) {
      let min = ''
      let minIndex = ''
      for (let i = 0; i < skus.length; i++) {
        const el = skus[i]
        if (el.display === '1' && (min === '' || el[property] < min)) {
          min = el[property]
          minIndex = i
        }
      }
      if (minIndex === '') {
        return {}
      } else {
        return skus[minIndex]
      }
    },
    // 查看活动详情
    handleActivityDetail(activity) {
      if (activity.showStock <= 0) {
        this.$message('该商品已售罄')
        return
      }
      this.$router.push({
        name: 'timeLimitDetail',
        params: {
          activityId: activity.activityId,
          commodityId: activity.commodityId
        }
      })
    },
    // 查询所有秒杀
    queryAllflashSale() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_queryIndexActivityCommodity))
      apiObj.param = {
        page: 0,
        size: 5,
        activityTypeList: [4]
      }
      http.postFrontMall(apiObj).then((res) => {
        const { code, message, value } = res.data
        if (Number(code) === 0) {
          this.flashSaleList = value
        } else {
          this.$message(message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .flashSale-container {
    // background: red;
    width: 1200px;
    margin: 20px auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    .titleBox {
      width: 100%;
      text-align: center;
      position: relative;
      font-weight: 500;
      .title {
        color: #333333;
        font-size: 20px;
        position: relative;
        .decoration {
          position: absolute;
          width: 10px;
          height: 10px;
          background: #7CC4F0;
          border-radius: 50%;
          top: 50%;
          transform: translateY(-50%);
          .decoration-line {
            position: absolute;
            width: 6px;
            height: 6px;
            background: #8FCDF3;
            top: 50%;
            transform: translateY(-50%);
          }
          &.left {
            left: -20px;
            .decoration-line {
              border-radius: 6px 0 0 6px;
              left: -4px;
            }
          }
          &.right {
            right: -20px;
            .decoration-line {
              border-radius: 0 6px 6px 0;
              right: -4px;
            }
          }
        }
      }
      .moreBox {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 16px;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        .lookMore {
          color: #666666;
        }
        /deep/ .el-icon-arrow-right {
          background: #C3C3C3;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          color: #FFFFFF;
          font-size: 14px;
          line-height: 16px;
        }
      }
    }

    .listBox {
      width: 100%;
      display: flex;
      gap: 20px;
      // background: #ffffff;
      height: 345px;
      align-items: center;
      .goodList {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 21px;
        .goodItem {
          cursor: pointer;
          width: 284px;
          height: 345px;
          background: #FFFFFF;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          .img {
            width: 100%;
            height: 282px;
            background: #E4E4E4;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            .soldOut1 {
              position: absolute;
              top: 0;
              left: 0;
              transform: scale(0.7);
            }
          }
          .info {
            flex: 1;
            padding: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .storeCommodity {
              display: flex;
              align-items: center;
              gap: 6px;
              img {
                height: 16px;
              }
              .commodityName {
                font-size: 14px;
                color: #333333;
                flex: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            .price {
              font-size: 14px;
              .retail {
                color: #333333;
                .symbol {
                  color: #333333;
                  font-size: 10px;
                }
              }
              .original {
                text-decoration: line-through;
                color: #cccccc;
                font-size: 10px;
                .symbol {
                  color: #cccccc;
                  font-size: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
